import lodashGroupBy from 'lodash/groupBy';

export function groupBy<Item, GroupKey extends string>(collection: Item[], iteratee: (v: Item) => GroupKey): Partial<Record<GroupKey, Item[]>> {
  return lodashGroupBy(collection, iteratee) as Record<GroupKey, Item[]>;
}
